import { render, staticRenderFns } from "./FinanceDept.vue?vue&type=template&id=90d2d61a&"
import script from "./FinanceDept.vue?vue&type=script&lang=js&"
export * from "./FinanceDept.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDept.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports